import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { NavigationOptions } from '@ionic/angular/common/providers/nav-controller';
import { PHOTODOCU_DEFAULT_TARGET_REF } from 'src/app/_pages/photodocu/photodocu.page';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { LoggingService } from '../../logging/logic/logging.service';
import { ServicejobsService } from '../../servicejobs/logic/servicejobs.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { IMSId, IMSObjectType } from 'src/app/_model/ims-object';
import { TourStopsService } from '../../tour-stop/logic/tour-stop.service';
import { AlertService } from '../../alert/alert.service';
import { BranchesService } from '../../branches/logic/branches.service';
import { AppParameterService } from '../../app-parameter/logic/app-parameter.service';

@Injectable({
  providedIn: 'root',
})
export class PhotodocuActionHandler implements ActionHandler {
  readonly name: ActionHandlerType = 'photodocu';

  constructor(
    private logger: LoggingService,
    private clientStateService: ClientStateService,
    private servicejobService: ServicejobsService,
    private navigationController: NavController,
    private router: Router,
    private tourStopsService: TourStopsService,
    private alertService: AlertService,
    private branchesService: BranchesService,
    private appParameterService: AppParameterService,
    private servicejobsService: ServicejobsService
  ) {}

  async executeAction(params?: any): Promise<any> {
    this.logger.log(
      this.constructor.name,
      'Photodocu triggered with params',
      params
    );
    const appParams = this.appParameterService.appParameters$.getValue();
    let targetRef: IMSObjectType =
      params && params['targetRef']
        ? params['targetRef']
        : PHOTODOCU_DEFAULT_TARGET_REF;
    let targetId =
      params && params['targetId']
        ? params['targetId']
        : params && params['obiId']
        ? params['obiId']
        : undefined;
    const pinId = params && params['pinId'] ? params['pinId'] : undefined;
    const pinLid = params && params['pinLid'] ? params['pinLid'] : undefined;

    const navOptions: NavigationOptions = {
      queryParams: {
        customBackUrl: this.router.url,
        targetRef: targetRef,
        targetId: targetId,
        pinId: pinId,
        pinLid: pinLid,
      },
    };

    if (targetRef === PHOTODOCU_DEFAULT_TARGET_REF) {
      const clientState = this.clientStateService.theState.getValue();
      if (clientState.serviceJobId == null) {
        this.logger.log(
          this.constructor.name,
          'servicejob not available',
          clientState.serviceJobId
        );
        return;
      }

      this.logger.log(
        this.constructor.name,
        'servicejob available',
        clientState.serviceJobId
      );
      const serviceJob = this.servicejobService.getServiceJobById(
        clientState.serviceJobId
      );

      if (serviceJob?.tagtemplatevalid?.getImsId()) {
        this.navigationController.navigateForward(
          `/feature/tagselect`,
          navOptions
        );
        return;
      }
    } else if (targetRef === 'ims/TourStop') {
      this.logger.log(
        this.constructor.name,
        'targetRef is TourStop',
        targetRef
      );
      const clientState = this.clientStateService.theState.getValue();
      if (clientState.tourStopId == null) {
        this.logger.log(
          this.constructor.name,
          'tourstop not available',
          clientState.tourStopId
        );
        return;
      }

      this.logger.log(
        this.constructor.name,
        'tourstop available',
        clientState.tourStopId
      );
      const tourStop = this.tourStopsService.getTourStopById(
        clientState.tourStopId
      );

      if (tourStop.branchIds.length === 1) {
        targetId = tourStop.branchIds[0];
        targetRef = 'ims/Branch';
      } else {
        let branchIds: IMSId[] = [];
        switch (appParams['imsmc.photodoc.tourstop.target-branch']) {
          case 'branch':
            console.log('JBSplit use default branch for tourstop photodoc');
            branchIds = tourStop.branchIds;
            break;
          case 'recipientbranch':
            console.log('JBSplit use recipientbranch for tourstop photodoc');
            branchIds = tourStop.servicejobIds.map((it) => {
              const sjob = this.servicejobsService.getServiceJobById(it);
              return sjob.recipientbranch.id;
            });
            break;
          case 'customerbranch':
            console.log('JBSplit use customerbranch for tourstop photodoc');
            branchIds = tourStop.servicejobIds.map((it) => {
              const sjob = this.servicejobsService.getServiceJobById(it);
              return sjob.customerbranch.id;
            });
            break;
        }
        const uniqueBranchIds = branchIds.reduce((acc, cur) => {
              if (acc.find((x) => x.imsId === cur.imsId) === undefined) {
                acc.push(cur);
              }
              return acc;
            }, [] as IMSId[]);
        await this.alertService.showAlert(
          'Geschäftspartner wählen',
          undefined,
          'Bitte wählen Sie einen Geschäftspartner aus, wessen Liefersituation Sie dokumentieren wollen',
          undefined,
          undefined,
          undefined,
          undefined,
          false,
          undefined,
          undefined,
          uniqueBranchIds.map((branchId: IMSId) => {
            const branch = this.branchesService.getBranchById(branchId)
            const branchButton: {
              text: string;
              handler: (data?: any) => void;
            } = {
              text: branch.displayLabel,
              handler: () => {
                console.log("PhotoDocuPage orig targetId and targetRef", targetId, targetRef);
                navOptions.queryParams.targetRef = "ims/Branch";
                navOptions.queryParams.targetId = JSON.stringify(branchId);

                console.log("PhotoDocuPage Navigate to targetId and targetRef", navOptions.queryParams.targetId, navOptions.queryParams.targetRef);
                this.navigationController.navigateForward(`/feature/photodocu`, navOptions);
              },
            };

            return branchButton;
          })
        );
        return;
      }
    }

    this.navigationController.navigateForward(`/feature/photodocu`, navOptions);
  }
}
